/**
 * Constants for save state feature
 */

export const STORAGE_KEY = 'rychle-sipy-a-velikonocni-poklad:progress' as const
